import { threePlayerReq, fourPlayerReq } from '@lc/const/season';
import { summitCardThresholds, summitDistributionDraft } from '@lc/const/summit';
import { GameState } from '@lc/interface/gameState/types';
import { setStateForPRTurnDecision } from '@lc/lib/gamestate_helper';
import { prepSummitDraft } from '@lc/lib/summit_helper';

class TimelineSummit {
	calculateContributionsAndTally = (
		gameState: GameState,
		ticker: string[]
	) => {
		let tally = 0; // tally of donated energy for summit

		const energyMap = new Map();
		energyMap.set('r', 0);
		energyMap.set('g', 0);
		energyMap.set('b', 0);
		energyMap.set('y', 0);

		// evaluate all players' active contracts and awards, need some kind of "pause" function
		// aka split up summit into it's own "month", where either we auto-progress if player has nothing
		// or wait for confirmation on any triggers that require player input

		// tracker of index of card being decided. reset to -1 per player, but the index will move backwards from n to 0

		// does this work for 'player donates x amount' even if not our color
		for (const player of gameState.playerStateArray) {
			ticker.unshift(
				'Player ' +
					player.id +
					' donated ' +
					player.donationCupArr.length
			);

			// 2, 4, 6, 

			while (player.donationCupArr.length > 0) {
				// empty cup
				const e = player.donationCupArr.pop();
				energyMap.set(e, energyMap.get(e) + 1);
				tally += 1;
			}
		}

		const energyRequirementArr =
			gameState.numPlayers === 3 ? threePlayerReq : fourPlayerReq;
		const energyRequirement = energyRequirementArr[gameState.seasonTracker];

		const carbonToll = energyRequirement - tally; // 10 - 6 (player dono)

		return { carbonToll: carbonToll, energyMap: energyMap };
	};

	// take their donation cups, empty them, get tally, subtract carbon if necessary
	async summit(
		gameState: GameState,
		isWinterSummit: boolean,
		ticker: string[]
	) {
		if (isWinterSummit) {
			console.log('Beginning Winter Summit!');
			ticker.unshift('Beginning Winter Summit!');
		} else {
			console.log('Beginning Summit!');
			ticker.unshift('Beginning Summit!');

			if (gameState.summitCardDistribution === summitDistributionDraft) {
				prepSummitDraft(gameState, ticker); // create populated data structures for summit card selection
			} else {
				setStateForPRTurnDecision(gameState, ticker);
			}
		}

		const { carbonToll, energyMap } = this.calculateContributionsAndTally(
			gameState,
			ticker
		);

		for (const player of gameState.playerStateArray) {
			const playerDonation = energyMap.get(player.energyColor);
			player.totalDonation += playerDonation;

			const donationThreshold = summitCardThresholds[gameState.seasonTracker];
			if (
				playerDonation >= donationThreshold &&
				gameState.DeckSummit.length > 0 &&
				gameState.DeckSummit[0] >= 0
			) {
				ticker.unshift(
					`Player ${player.id} earned a Summit card. Donated ${playerDonation}, threshold was ${donationThreshold}`
				);
				const currSummitCard =
					gameState.DeckSummit.shift() as number;
				player.summitCards.push(currSummitCard);
			}
		}

		if (carbonToll > 0) {
			gameState.carbonReservoir -= carbonToll;
			gameState.worldEnergy.carbon += carbonToll;
			ticker.unshift('Players failed to donate enough energy');
			ticker.unshift(carbonToll + ' carbon lost from reservoir');
			ticker.unshift(gameState.carbonReservoir + ' carbon remains');
		} else {
			// TODO mark players with donation req order
			ticker.unshift('Energy requirement met! Advancing to next season');
		}

		if (gameState.carbonReservoir < 0 && carbonToll > 0) {
			gameState.gameStatus = 1;
			console.log('Game over :(');
			ticker.unshift('Game over :(');
		} else if (isWinterSummit) {
			gameState.gameStatus = 2;
			console.log('Game Complete! You won!');
			ticker.unshift('Game Complete! You won!');
		}

		// This doesn't do well with the 3 to 4 player id
		// does this account for other colors in the pool?
		const redDonation = energyMap.get('r');
		const greenDonation = energyMap.get('g');
		const blueDonation = energyMap.get('b');
		const yellowDonation = energyMap.get('y');

		// create summitDraft

		gameState.worldEnergy.red += redDonation;
		gameState.worldEnergy.green += greenDonation;
		gameState.worldEnergy.blue += blueDonation;
		gameState.worldEnergy.yellow += yellowDonation;
	}
}

export const timeline_summit = new TimelineSummit();
